
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import Placeholder from '../../../common/placeholder/Placeholder';
import formatDateToBR from '../../../utils/formatDateToBR';
// import TruncatedContent from '../../../utils/TruncatedContent';

class NewsMostRead extends Component {
    _mapNews() {
        return this.props.dataNews.map((data) => (
            <li key={data.slug}>
                <p className="tw-text-[#777C86] tw-m-0 tw-text-xs" alt="Data de publicação da matéria">
                    {formatDateToBR(data.date)}
                </p>
                <Button
                    title={data.title}
                    to={`/noticias/${data.slug}`}
                    className="tw-font-bold limitText2"
                >
                    {data.title}
                </Button>
                <Button
                    title={data.title}
                    to={`/noticias/${data.slug}`}
                    className="tw-mt-5 tw-block"
                >
                    <img src={`https://a1media.antena1.com.br/image/news/320x168/${data.imageNew}`} alt={`imagem da noticia ${data.title}`} />
                </Button>

                <div className="tw-mt-5">
                    <p className="tw-text-sm limitText2">
                        {data.subtitle}
                    </p>
                </div>
            </li>

        ));
    }

    render() {
        return (
            <aside className="newsMostRead">
                <div className="title">
                    <h3 className="tw-text-left">
                        {this.props.title}
                    </h3>
                </div>
                {!this.props.isFetching ?
                    <ul>
                        {this.props.dataNews && this.props.dataNews.length > 0 ?
                            this._mapNews() :
                            <Button title="Ir para Home" to="/">Não há notícias para serem exibidas.</Button>}
                    </ul>
                    : <Placeholder minHeight="509px" />}
            </aside>
        );
    }
}

NewsMostRead.propTypes = exact({
    dataNews: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    isFetching: PropTypes.bool,
});


export default NewsMostRead;
